<div class="header-container">
  <div class="tab-title">
    <h2>{{ currentTab }}</h2>
  </div>
  
  <div class="user-actions">
    <a class="action-link" (click)="goToMyAccount()">
      <i class="fas fa-home"></i> My Account
    </a>
    <a class="action-link" (click)="logout()">
      <i class="fas fa-sign-out-alt"></i> Logout
    </a>
  </div>
</div>
